import React from "react";
import { Box, Stack, Typography, TextField, Select, MenuItem } from "@mui/material";
import { MONTHS } from "../../../constants/recurrenceConstants";

const YearlyPicker = ({ values, set }) => (
  <Box>
    <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#475569", mb: 1.5 }}>
      Repeat every year in
    </Typography>
    <Stack direction="row" alignItems="center" gap={1.5} flexWrap="wrap">
      <Select
        size="small"
        value={values.recurrenceMonth ?? 0}
        onChange={(e) => set("recurrenceMonth", e.target.value)}
        sx={{ minWidth: 130, fontSize: "13px" }}
      >
        {MONTHS.map((m, i) => (
          <MenuItem key={i} value={i} sx={{ fontSize: "13px" }}>{m}</MenuItem>
        ))}
      </Select>

      <Typography sx={{ fontSize: "13px", color: "#64748B", fontWeight: 500 }}>
        on day
      </Typography>

      <TextField
        type="number"
        size="small"
        value={values.recurrenceDayOfMonth}
        onChange={(e) =>
          set("recurrenceDayOfMonth", Math.min(31, Math.max(1, parseInt(e.target.value) || 1)))
        }
        inputProps={{ min: 1, max: 31 }}
        sx={{ width: 70 }}
      />
    </Stack>
  </Box>
);

export default YearlyPicker;
